export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "labels": {
          "go_back_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Volver a la lista de proveedores"])},
          "total_number_crop_field_certifications": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Certificaciones"])},
          "new_crop_field_certifications_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Añadir certificación"])},
          "edit_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Editar"])},
          "destroy_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Eliminar"])},
          "destroy_button_label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Eliminar"])},
          "destroy_button_title": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Eliminar certificación ", _interpolate(_named("certification_name"))])},
          "destroy_button_message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["¿Está seguro de eliminar la certificación?"])},
          "destroy_button_label_confirm": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Eliminar"])},
          "expired_date": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vencido"])},
          "days": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["En ", _interpolate(_named("days")), " días"])}
        }
      }
    }
  })
}